import { createFileRoute } from "@tanstack/react-router";
import { CreditsScreen } from "@ui/screens/CreditsScreen";

export const Route = createFileRoute("/credits")({
  component: CreditsScreen,
});
